
import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import TruckTemplateModule from "@/store/modules/truckTemplate";
import Component from "vue-class-component";
import {
  TruckTemplateListItem,
  GetTruckTemplateRequest
} from "@/models/api/truckTemplate/getTruckTemplates";
import { Watch } from "vue-property-decorator";
import notifications from "../../lib/notifications";

const truckTemplateModuleState = getModule(TruckTemplateModule);

@Component({})
export default class TruckTemplateSummary extends Vue {
  showTruckTemplateFieldFilter: boolean = false;
  showTruckTemplates: boolean = false;
  truckTemplateMenuStyle: string = "";
  clickLocation: any = null;
  facilityCode: string = null;

  get truckTemplateFields() {
    return truckTemplateModuleState.truckTemplateFields;
  }

  get pageNumber(): number {
    return truckTemplateModuleState.pageData.currentPage;
  }

  set pageNumber(val) {
    truckTemplateModuleState.setCurrentPage(val);
  }
  get pageSize(): number {
    return truckTemplateModuleState.pageData.pageSize;
  }

  get totalItems(): number {
    return truckTemplateModuleState.pageData.totalItems;
  }

  get loading(): boolean {
    return truckTemplateModuleState.loading;
  }

  get truckTemplates(): Array<TruckTemplateListItem> {
    return truckTemplateModuleState.data;
  }

  @Watch("pageNumber")
  pageChanged(val) {
    this.loadMoreTruckTemplates();
  }

  async created() {
    this.loadMoreTruckTemplates();
  }

  async loadMoreTruckTemplates() {
    await truckTemplateModuleState.setLoading(true);
    await truckTemplateModuleState.getTruckTemplates({
      pageNumber: this.pageNumber,
      pageSize: truckTemplateModuleState.pageData.pageSize,
      facilityFilter: this.facilityCode
    } as GetTruckTemplateRequest);
    await truckTemplateModuleState.setLoading(false);
  }

  async deleteRecord(id: number) {
    const confirmed = await this.$bvModal.msgBoxConfirm(
      "Are you sure you want to delete this record? This action cannot be undone."
    );
    if (confirmed) {
      try {
        await truckTemplateModuleState.deleteTruckTemplate({ truckTemplateId: id, confirm: true });
        await this.loadMoreTruckTemplates();
        notifications.success("Delete Truck Template", "Record successfully deleted.");
      } catch (ex) {
        notifications.error("Delete Truck Template", "Failed to delete record", ex);
      }
    }
  }

  newTruckTemplate() {
    this.$router.push({ name: "NewTruckTemplate" });
  }
}
